var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClipboard = function SvgClipboard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.66699H12.0001C12.3537 2.66699 12.6928 2.80747 12.9429 3.05752C13.1929 3.30756 13.3334 3.6467 13.3334 4.00033V13.3337C13.3334 13.6873 13.1929 14.0264 12.9429 14.2765C12.6928 14.5265 12.3537 14.667 12.0001 14.667H4.00008C3.64646 14.667 3.30732 14.5265 3.05727 14.2765C2.80722 14.0264 2.66675 13.6873 2.66675 13.3337V4.00033C2.66675 3.6467 2.80722 3.30756 3.05727 3.05752C3.30732 2.80747 3.64646 2.66699 4.00008 2.66699H5.33341",
    stroke: "#60666E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 1.33301H5.99992C5.63173 1.33301 5.33325 1.63148 5.33325 1.99967V3.33301C5.33325 3.7012 5.63173 3.99967 5.99992 3.99967H9.99992C10.3681 3.99967 10.6666 3.7012 10.6666 3.33301V1.99967C10.6666 1.63148 10.3681 1.33301 9.99992 1.33301Z",
    stroke: "#60666E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClipboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clipboard.2bcd937d57622e129b4c62d3e5e635ac.svg";